import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../providers/ConfigProvider';
import BottomSheet from './BottomSheet';
import useVetStore from '../store/vetStore';
import { fetchById } from '../utils/lib';
import EditIcon from '@mui/icons-material/Edit';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import GroupIcon from '@mui/icons-material/Group';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import WarehouseIcon from '@mui/icons-material/Warehouse';

/**
 * Menú inferior de acciones de la veterinaria (mismo que en ViewVet).
 * Si no se pasa `vet`, se carga el registro completo con la API.
 */
function VetActionsBottomSheet({ vet: vetProp }) {
  const [vet, setVet] = useState(vetProp ?? null);
  const navigate = useNavigate();
  const { resetVet } = useVetStore();
  const { t } = useTranslation();
  const { config } = useConfig();

  useEffect(() => {
    if (vetProp != null) {
      setVet(vetProp);
    }
  }, [vetProp]);

  useEffect(() => {
    if (vetProp != null || !config?.vet?.id) return;
    let cancelled = false;
    (async () => {
      try {
        const v = await fetchById(config.vet.id, 'vets');
        if (!cancelled) setVet(v);
      } catch {
        /* ignore */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [vetProp, config?.vet?.id]);

  if (!vet) return null;

  const handleEdit = () => {
    resetVet();
    navigate('/edit-vet', { state: { updateVet: vet } });
  };

  const handleServices = () => {
    navigate('/main/view-vet-services-schedules');
  };

  const handleUsers = () => {
    navigate('/main/view-vet-users');
  };

  const handleCreateBranch = () => {
    resetVet();
    navigate('/edit-vet', { state: { isBranch: true } });
  };

  const handleReceipts = () => {
    navigate('/main/view-vet-points', { state: { vet } });
  };

  const handleWarehouses = () => {
    navigate('/main/view-vet-deposits', { state: { vet } });
  };

  return (
    <BottomSheet
      zIndex={1001}
      buttonGroups={[
        {
          label: t('view.vetActionsGroupTitle'),
          buttons: [
            {
              label: t('view.vetActionEdit'),
              action: handleEdit,
              icon: <EditIcon />,
            },
            {
              label: t('view.vetActionServicesSchedules'),
              action: handleServices,
              icon: <DesignServicesIcon />,
            },
            {
              label: t('view.vetActionUsers'),
              action: handleUsers,
              icon: <GroupIcon />,
            },
            {
              label: t('view.vetActionCreateBranch'),
              action: handleCreateBranch,
              icon: <StorefrontIcon />,
            },
            {
              label: t('view.vetActionReceipts'),
              action: handleReceipts,
              icon: <PointOfSaleIcon />,
            },
            {
              label: t('view.vetActionWarehouses'),
              action: handleWarehouses,
              icon: <WarehouseIcon />,
            },
          ],
        },
      ]}
    />
  );
}

export default VetActionsBottomSheet;
